import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=e81ae274"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports